import React from 'react';
import './CategoryWiseArtist.css';
import { API_BASE_URL } from '../../utils';

const IMAGE_BASE = `${API_BASE_URL}/master/assets/uploads/`;

export default function CategoryWiseArtist({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="category-artist-wrapper">
      {data
        .filter((category) => category.artist_list.length > 0)
        .map((category) => (
          <div className="category-artist-category" key={category.id}>
            <h2 className="category-artist-category-title">{category.name}</h2>
            <div className="category-artist-list">
              {category.artist_list.map((artist) => (
                <div className="category-artist-card-horizontal" key={artist.id}>
                  <img
                    src={`${IMAGE_BASE}${artist.profile_pic}`}
                    alt={artist.name}
                    className="category-artist-img-horizontal"
                  />
                  <div className="category-artist-info-horizontal">
                    <h3 className="category-artist-name">{artist.name}</h3>
                    <p className="category-artist-genre">{artist.genre}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}
